<template>
  <div class="image-container">
    <v-img
      v-if="imageUrl"
      :src="imageUrl"
      contain
      class="ma-auto"
      :max-height="small ? '100px' : 500"
      :max-width="small ? '100px' : 'auto'">
    </v-img>
    <div v-else class="placeholder-container">
      <span style="display: block; margin: auto">
        <small>Image not available</small>
      </span>
    </div>
  </div>
</template>
<script>
import Images from '@/api/images'
import { displayAlert } from '@/mixins/alert'
export default {
  data() {
    return {
      itemImageUrl: null
    }
  },
  name: 'ProductImage',
  mixins: [displayAlert],
  props: {
    product: Object,
    small: {
      type: Boolean,
      default: false
    },
    is_item: {
      type: Boolean,
      default: false
    },
    imageCache: Object
  },
  async created() {
    if (this.is_item && this.product?.upc) {
      // check if lookup has occurred previously 
      // NOTE: property-based evaluation is deliberate, API returns null if no image is found
      if (this.imageCache?.hasOwnProperty(`${this.product.upc}`)) {
        this.itemImageUrl = this.imageCache[this.product.upc]
      } else {
        await this.getItemImage(this.product.upc)
      }
    }
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_SEASONAL_IMG_URL
    },
    imageUrl() {
      if (this.product?.seasonal && this.product?.upc && !this.product.image_url) {
        let { upc } = this.product
        if (upc.length > 11) {
          upc = this.getNormalizedUPC(upc)
        }
        return `${this.baseUrl}/${upc}.gif`
      }
      return this.is_item ? this.itemImageUrl : this.product.image_url
    }
  },
  methods: {
    getNormalizedUPC(upc) {
      const diff = (upc.length - 11)
      const start = (diff - 1)
      const end = upc.length - (Math.sign(start + 1))
      return upc.substring(start, end)
    },
    async getItemImage(upc) {
      let url = null
      try {
        const { data } = await Images.get(upc)
        if (data?.presigned_image_url) {
          this.itemImageUrl = data.presigned_image_url
          url = data.presigned_image_url
        }
        this.$emit('updateImageCache', upc, url)
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>
<style scoped>
.image-container {
  display: grid;
  justify-content: center;
  min-height: 100px;
}

.placeholder-container {
  display: grid;
  justify-content: center;
  align-content: center;
  height: 100px;
  padding: 15px;
  margin: auto;
  text-align: center;
  border: 1px solid #eee; 
}
</style>